function usePageIdentifier() {
  // 1- get page title
  const homePageUrl = "https://www.thegoodguys.com.au";
  const homePageUtlTst = "https://tstauthv8.thegoodguys.com.au";
  const homePageUtlPrd = "https://prdauthv8.thegoodguys.com.au";
  const homePageUtlUat = "https://uatauth.thegoodguys.com.au";
  const pageFullUrl = document.querySelector("link[rel='canonical']").getAttribute("href");
  let pageTitle = null;
  if (
    pageFullUrl === homePageUrl ||
    pageFullUrl === homePageUtlTst ||
    pageFullUrl === homePageUtlPrd ||
    pageFullUrl === homePageUtlUat
  ) {
    pageTitle = "home-page";
    //console.log(pageTitle)
  } else {
    pageTitle = pageFullUrl.substring(
      pageFullUrl.lastIndexOf("/") + 1,
      pageFullUrl.length
    );
    //console.log(pageTitle)
  }
   return {
    pageTitle,
  };
}

export default usePageIdentifier;
